import React from 'react'
import { SelectComponent } from '../../shared/select/select.component'
import moment from 'moment';
moment.locale('ru');

export class PickupConds extends React.Component {
  render() {
    return (
      <div>
        Выбор точки выдачи
      </div>
    )
  }
}

export class DeliveryPeriods extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ind: 0
    }

  }

  currentInd() {
    let ord = this.props.ord

    const d_p = this.props.settings.delivery_periods_json
    for(let i = 0; i < d_p.length; i++) {
      if(d_p[i].from == ord.time_from && d_p[i].to == ord.time_to) {
        return i
      }
    }

    return 0
  }

  componentWillMount() {
    setTimeout(()=> {
      this.orderChanged({target: {value: this.currentInd()}})
    }, 100)

  }

  orderChanged(e) {
    const ind = e.target.value
    const it = this.props.settings.delivery_periods_json[ind]
    this.props.onChange(it)
  }

  render() {
    const ord = this.props.ord
    const prms = this.props.settings
    const opts = prms.delivery_periods_json.map((it, ind)=> {
      return {
        id: ind,
        title: it.title
      }
    })
    return (
      <div>
        <h4>Период доставки</h4>
        <SelectComponent
          opts={opts}
          value={this.currentInd()}
          onChange={ (e)=> { this.orderChanged(e) } }
        />
      </div>
    )
  }
}

export class DeliveryDateChoose extends React.Component {
  constructor(props) {
    super(props)
    let current = moment()
    this.state = {
      day: current.date(),
      month:  current.month(),
      year: current.year()
    }

    this.years = [
      {id: this.state.year, title:this.state.year},
      {id: this.state.year + 1, title:this.state.year + 1}
    ]

    this.months = [
      {id: 0, title: 'Январь'},
      {id: 1, title: 'Февраль'},
      {id: 2, title: 'Март'},
      {id: 3, title: 'Апрель'},
      {id: 4, title: 'Май'},
      {id: 5, title: 'Июнь'},
      {id: 6, title: 'Июль'},
      {id: 7, title: 'Август'},
      {id: 8, title: 'Сентябрь'},
      {id: 9, title: 'Октябрь'},
      {id: 10, title: 'Ноябрь'},
      {id: 11, title: 'Декабрь'}
    ]


    this.genDays()

    setTimeout(()=> {
      if(!props.date) {
        this.changed()
      }
    }, 100)

  }

  setDate(arr) {
    this.setState((ps)=> {
      ps.day = arr[2]
      ps.month = arr[1] - 1
      ps.year = arr[0]
      return ps
    })
  }

  lastDayOfMonth(st) {
    return moment([st.year, st.month, 1]).daysInMonth()
  }

  genDays(n = 31) {
    this.days = []
    let i = 1
    while(i <= n) {
      this.days.push({id:i, title:i})
      i++
    }
  }

  paramChanged(name, e) {
    this.setState((ps)=> {
      ps[name] = e.target.value
      if(name == 'month' || name == 'year') {
        let lastDay = parseInt(this.lastDayOfMonth(ps))
        this.genDays(lastDay)
        if(ps['day'] > lastDay) {
          ps['day'] = lastDay
        }
      }
      return ps
    }, ()=> {
      this.changed()
    })
  }

  changed() {
    if(!this.props.onChange)
      return
    const s = this.state

    this.props.onChange([s.day, s.month+1, s.year].join('.'))
  }

  correctDays() {

  }

  render() {
    return (
      <div>
        <h4>Выбор даты</h4>
        <div className="row">
          <div className="col-12 col-sm-2">
            <SelectComponent
              opts={this.days}
              value={this.state.day}
              onChange={ (e)=> { this.paramChanged('day', e) } }
            />
          </div>
          <div className="col-12 col-sm-6">
            <SelectComponent
              opts={this.months}
              value={this.state.month}
              onChange={ (e)=> { this.paramChanged('month', e) } }
            />
          </div>
          <div className="col-12 col-sm-4">
            <SelectComponent
              opts={this.years}
              value={this.state.year}
              onChange={ (e)=> { this.paramChanged('year', e) } }
            />
          </div>
        </div>
        <br/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/make_order/delivery_conds.component.jsx